module.exports = __webpack_public_path__ + "static/media/choithramsRecipeOne.b5becd53.png";